import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../redux/axios/axios";
const fetchSocialLinks = async () => {
  try {
    const response = await axiosInstance.get("/media-links");
    return response.data;
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};

const useSocialLinkss = () => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["socialLinks"],
    queryFn: fetchSocialLinks,
  });
  return { data, isLoading, isError, error };
};

export default useSocialLinkss;
